import React from 'react';
import MediaViewer from '@shared/MediaViewer';
import { Wrapper } from './styles';

const MediaViewerModal = (props) => <Wrapper><MediaViewer {...props} /></Wrapper>;

export default MediaViewerModal;
